import IFFFChangeHandlerEvent from './IFFFChangeHandlerEvent';
import { IFieldState, IListFieldState, IRecurlyFieldState } from './index';

export function isFieldState(
  fs: IFieldState | IRecurlyFieldState | IListFieldState,
): fs is IFieldState {
  return (fs as IFieldState).value !== undefined;
}

interface IBaseField {
  errorMsg: string;
  hasError: boolean;
  isTouched: boolean;
  changeHandler: (event: IFFFChangeHandlerEvent) => void;
  blurHandler: () => void;
  focusHandler: (eventData?: { fieldName: string; section: string; formType: string }) => void;
  onSubmit: (error: string) => void;
  lastPostSubmitError: string;
}

export default IBaseField;
